( function( $ ) {
	let savedModal, deletedModal, confirmClearModal, clearAllBtn, totalBanner;
	const cookieName = 'syr_saved';
	const savedClass = 'save-facility__btn--saved';
	const delineator = '|';
	const containerSelector = '.facility-result, .facility-details__overview-btns';
	let btnContainers;
	let otherBannerHeight = 0;

	document.addEventListener( 'DOMContentLoaded', init );

	// fired by facilities-ajax.js
	document.body.addEventListener( 'facility-result-rendered', init );

	function init() {
		btnContainers = document.querySelectorAll( containerSelector );
		if( !btnContainers ) { return; }

		if( !savedModal ) {
			savedModal = document.getElementById( 'saved-facility-confirmation' );
			if( savedModal ) {
				savedModal.querySelector( '.save-facility__modal-undo' ).addEventListener( 'click', undoSave );
			}
		}
		if( !deletedModal ) {
			deletedModal = document.getElementById( 'saved-facility-deleted' );
		}

		if( !confirmClearModal ) {
			confirmClearModal = document.getElementById( 'clear-all-facility-confirmation' );
			if( confirmClearModal ) {
				clearAllBtn = confirmClearModal.querySelector( '.save-facility__modal-confirm-clear' );
				if( clearAllBtn ) { clearAllBtn.addEventListener( 'click', clearAll ); }
			}
		}

		if( !totalBanner ) {
			totalBanner = document.getElementById( 'saved-facility-total' );

			if( totalBanner ) {
				// offset from other sticky elements
				const banner = document.querySelector( '.availability-banner, .facility-details__sticky' );
				if( banner ) {
					otherBannerHeight = ( banner.clientHeight + 16 ) + 'px';
				}

				// adjust offset when other banner sticks/unsticks
				document.body.addEventListener( 'facility-detail-sticky-changed', () => {
					totalBanner.style.paddingBottom = document.querySelector( '.facility-details__sticky' ).classList.contains( 'facility-details__sticky--active' ) ? otherBannerHeight : '';
				} );

				const observer = new IntersectionObserver( 
					( [entry] ) => {
						const inView = entry.intersectionRatio < 1;
						entry.target.classList.toggle( 'save-facility__total--stuck', inView );
					},
					{ threshold: [1] }
				);

				observer.observe( totalBanner );
			}
		}

		const savedFacilities = getSavedFacilities();
		Array.from( btnContainers ).forEach( ( container ) => initBtns( container, savedFacilities ) );

		updateTotalBanner( savedFacilities );
	}

	function updateTotalBanner( savedFacilities ) {
		if( !totalBanner ) { return; }
		if( !savedFacilities ) { savedFacilities = getSavedFacilities(); }

		if( savedFacilities.length ) {
			totalBanner.querySelectorAll( '.save-facility__total-txt' ).forEach( ( t ) => {
				t.textContent = savedFacilities.length;
			} );

			if( savedFacilities.length === 1 ) {
				totalBanner.querySelector( '.save-facility__total-plural' ).style.display = 'none';
				totalBanner.querySelector( '.save-facility__total-singular' ).style.display = 'block';
			} else {
				totalBanner.querySelector( '.save-facility__total-plural' ).style.display = 'block';
				totalBanner.querySelector( '.save-facility__total-singular' ).style.display = 'none';
			}

			totalBanner.style.display = 'flex';
		} else {
			totalBanner.style.display = 'none';
		}
	}

	function initBtns( btnContainer, savedFacilities ) {
		if( !savedFacilities ) { savedFacilities = getSavedFacilities(); }

		// get the current state of this facility
		const facilityid = btnContainer.dataset.facilityid;
		const saveBtn = btnContainer.querySelector( '.save-facility__btn' );
		if( !saveBtn ) { return; }

		let textEle;
		if( savedFacilities.includes( facilityid ) ) {
			saveBtn.classList.add( savedClass );
			textEle = saveBtn.querySelector( '.save-facility__btn--saved-txt' );
			if( textEle.children.length ) { textEle = textEle.children[textEle.children.length - 1]; }
			saveBtn.setAttribute( 'title', textEle.textContent );
		} else {
			textEle = saveBtn.querySelector( '.save-facility__btn--save-txt' );
			if( textEle.children.length ) { textEle = textEle.children[textEle.children.length - 1]; }
			saveBtn.setAttribute( 'title', textEle.textContent );
		}

		saveBtn.addEventListener( 'click', clickBtn );
	}

	function clickBtn( e ) {
		const saveBtn = e.target.closest( '.save-facility__btn' );
		const btnContainer = saveBtn.closest( containerSelector );

		if( saveBtn.classList.contains( savedClass ) ) {
			deleteFacility( btnContainer );
		} else {
			saveFacility( btnContainer );
		}
	}

	function saveFacility( btnContainer ) {
		const facilityid = btnContainer.dataset.facilityid;
		if( !facilityid ) {
			// eslint-disable-next-line no-console
			console.error( 'Missing facility id for', btnContainer );
			return;
		}

		let savedCookies = getSavedFacilities();
		if( !savedCookies.includes( facilityid ) ) { // not already saved
			savedCookies.push( facilityid );
			document.cookie = `${cookieName}=${ savedCookies.join( delineator )};path=/`;
		}
		
		updateTotalBanner( savedCookies );
		updateModalContent( savedModal, btnContainer  );

		// update all buttons that match this facilityid
		Array.from( document.querySelectorAll( containerSelector ) ).filter( card => card.dataset.facilityid === facilityid ).forEach( container => {
			const saveBtn = container.querySelector( '.save-facility__btn' );
			saveBtn.classList.add( savedClass );
			saveBtn.setAttribute( 'title', saveBtn.querySelector( '.save-facility__btn--saved-txt' ).textContent );
		} );
	}

	function updateModalContent( whichModal, btnContainer ) {
		const facilityName = ( btnContainer.querySelector( '.facility-result__title a' ) || document.querySelector( 'h1' ) ).textContent;
		const facilityImg = btnContainer.querySelector( '.image-carousel img' );

		const modalImg = whichModal.querySelector( '.save-facility__modal-img' );
		modalImg.textContent = ''; // clear it out
		if( facilityImg ) {
			modalImg.appendChild( facilityImg.cloneNode() );
		}

		whichModal.querySelector( '.save-facility__modal-name' ).textContent = facilityName;

		const undoBtn = whichModal.querySelector( '.save-facility__modal-undo' );
		if( undoBtn ) { undoBtn.dataset.facilityid = btnContainer.dataset.facilityid; }
		
		$( whichModal ).modal( 'show' ); // Bootstrap requires jQuery
	}

	function undoSave( e ) {
		const btnContainer = getbtnContainerById( e.target.dataset.facilityid );
		
		// Bootstrap requires jQuery
		// wait for it to be hidden before showing the next one so the body classes update correctly
		$( savedModal ).one( 'hidden.bs.modal', function() {
			deleteFacility( btnContainer );
		} ).modal( 'hide' );
	}

	function deleteFacility( btnContainer ) {
		const facilityid = btnContainer.dataset.facilityid;
		if( !facilityid ) {
			// eslint-disable-next-line no-console
			console.error( 'Missing facility id for', btnContainer );
			return;
		}

		const savedFacilities = getSavedFacilities();
		const newSavedFacilities = savedFacilities.filter( id => id !== facilityid );
		document.cookie = `${cookieName}=${newSavedFacilities.join( delineator )};path=/`;

		updateTotalBanner( newSavedFacilities );
		updateModalContent( deletedModal, btnContainer );

		const saveBtn = btnContainer.querySelector( '.save-facility__btn' );

		if( saveBtn.dataset && saveBtn.dataset.saveFacilityRemove ) {
			btnContainer.style.display = 'none';

			if( !Array.from( document.querySelectorAll( containerSelector ) ).find( card => card.style.display !== 'none' ) ) {
				// none are visible, redirect to the same place as the clear all button
				const redirect = getClearAllRedirectLink();
				if( redirect ) {
					window.location = redirect;
					return;
				}
			}
		}

		// update all buttons that match this facilityid
		Array.from( document.querySelectorAll( containerSelector ) ).filter( card => card.dataset.facilityid === facilityid ).forEach( container => {
			const saveBtn = container.querySelector( '.save-facility__btn' );
			saveBtn.classList.remove( savedClass );
			saveBtn.setAttribute( 'title', saveBtn.querySelector( '.save-facility__btn--save-txt' ).textContent );
		} );
	}

	function getSavedFacilities() {
		let cookieValue = document.cookie.split( '; ' ).find( row => row.startsWith( `${cookieName}=` ) );
		if( cookieValue ) { cookieValue = cookieValue.split( '=' )[1]; }
		if( !cookieValue ) { return []; }

		return cookieValue.split( delineator );
	}

	function getbtnContainerById( facilityid ) {
		return Array.from( document.querySelectorAll( containerSelector ) ).find( card => card.dataset.facilityid === facilityid );
	}

	function clearAll() {
		document.cookie = `${cookieName}=;path=/`;
		const redirect = getClearAllRedirectLink();
		if( redirect ) {
			window.location = redirect;
		} else {
			updateTotalBanner( [] );
			$( confirmClearModal ).modal( 'hide' );
		}
	}

	function getClearAllRedirectLink() {
		if( clearAllBtn && clearAllBtn.dataset.redirect ) {
			// resolve any relativitiy with the link and go there
			const tempLink = document.createElement( 'a' );
			tempLink.setAttribute( 'href', clearAllBtn.dataset.redirect );
			return tempLink.href;
		}

		return null;
	}
} )( jQuery );